// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"320dfc1e","162":"8598ef79","347":"320dfc1e","408":"320dfc1e","549":"320dfc1e","655":"320dfc1e","821":"320dfc1e"}[chunkId] + ".chunk.css";
};